/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ share: NonNullable<unknown> }} Platform_View_Plan_DoneInputs */

const en_platform_view_plan_done = /** @type {(inputs: Platform_View_Plan_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share}% of sessions done`)
};

const pl_platform_view_plan_done = /** @type {(inputs: Platform_View_Plan_DoneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.share}% zrobionych treningów`)
};

/**
* | output |
* | --- |
* | "{share}% of sessions done" |
*
* @param {Platform_View_Plan_DoneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_view_plan_done = /** @type {((inputs: Platform_View_Plan_DoneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_View_Plan_DoneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_view_plan_done(inputs)
	return en_platform_view_plan_done(inputs)
});